module.exports = __webpack_public_path__ + "static/img/login6.dcdc7472.png";